export const AVAILABLE_PERMISSIONS = [
    'canSearch',
    'canCreateEntries',
    'canUpdateEntries',
    'canMarkEntriesChecked',
    'canMarkEntriesConfirmed',
    'canViewUsers',
    'canCreateUsers',
    'canCreateMappings',
    'canViewBacklogs',
    'canAccessAnalyzer',
    'canCreateTags',
    'canViewDashboard',
    'canAccessVideoDownloader',
    'canAddEntryToReport',
    'canViewOwnEntries',
    'canDeleteNewsEntries',
    'canManageRoles',
    'canTranslateNewsEntry',
    'canViewStatsAndGraphs',
    'canAccessSiteManagement',
    'canViewRoles',      // New permission for reading roles
    'canChangeRoles'    // Existing permission for managing roles
  ] as const;

  export type Permission = typeof AVAILABLE_PERMISSIONS[number];